const DEFAULT_PROMPT =
  "Developer CAO Mode is active. Create the private Developer Scout, check Codex Responses hourly, and keep global app-user FS support tickets out of developer mode unless TP explicitly approves filing one.";

export interface DeveloperCaoLink {
  prompt: string;
  repo: string;
  plan: string;
  sprint: string;
  goal: string;
  delayMinutes: number;
  model: string;
  source: string;
}

export function parseDeveloperCaoLink(rawUrl: string): DeveloperCaoLink | null {
  try {
    const url = new URL(rawUrl);
    if (url.protocol.toLowerCase() !== "fintheon:") return null;
    const host = url.hostname.toLowerCase();
    const path = url.pathname.replace(/^\/+/, "").toLowerCase();
    if (host !== "developer-cao" && path !== "developer-cao") return null;
    const prompt = url.searchParams.get("prompt")?.trim();
    const sprint = normalizeSprint(
      url.searchParams.get("sprint") || url.searchParams.get("orchestrate"),
    );
    return {
      prompt: prompt || DEFAULT_PROMPT,
      repo: url.searchParams.get("repo")?.trim() || "",
      plan: url.searchParams.get("plan")?.trim() || "",
      sprint,
      goal: url.searchParams.get("goal")?.trim() || DEFAULT_PROMPT,
      delayMinutes: readDelay(url.searchParams.get("delay")),
      model: url.searchParams.get("model")?.trim() || "gpt-5.5",
      source: url.searchParams.get("source")?.trim() || "developer-cao-cli",
    };
  } catch {
    return null;
  }
}

export function parseDeveloperCaoPrompt(rawUrl: string): string | null {
  return parseDeveloperCaoLink(rawUrl)?.prompt ?? null;
}

function readDelay(value: string | null): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 30;
}

function normalizeSprint(value: string | null): string {
  const raw = value?.trim().toUpperCase().replace(/^S/, "") ?? "";
  return /^\d+$/.test(raw) ? `S${raw}` : "";
}
